export const firstStatusError = "Cannot read property 'status' of undefined"
export const secondStatusError = "undefined is not an object (evaluating 'e.response.status')"
export const authorizationError = 'Authorization error'
export const accessDeniedError = 'Access Denied'
